export default {
  inserted: function (el, binding, vnode) {
    // 如果兼容placeholder则终止
    if ("placeholder" in document.createElement("input")) {
      return;
    }
    // select暂时不支持(input为只读状态时)
    var isReadOnly = el.getAttribute("readOnly");
    if (isReadOnly) return;
    // 由于第三方input组件都包了一个外层
    var input = el.querySelector("input");
    var placeholder = input.getAttribute("placeholder");
    var span = document.createElement("span");
    //可根据类名自定义样式
    span.className = "placeholder";
    span.innerText = placeholder;
    // 位置设置
    span.style.left = input.offsetLeft + "px";
    input.parentNode.appendChild(span);
    el.addEventListener("click", function (event) {
      if (event.target.nodeName == "SPAN") {
        // span.style.display = "none";
        input.focus();
      }
    });
    span.addEventListener("click", function (event) {
      // span.style.display = "none";
      input.focus();
    });
    input.onblur = function (event) {
      if (!event.target.value) {
        span.style.display = "inline";
      }
    };
    input.oninput = function (event) {
      if (event.target.value) {
        span.style.display = "none";
      } else {
        span.style.display = "inline";
      }
    };
  },

  // 开始更新
  unbind: function (el) {
    var input = el.querySelector("input");
    input.onfocus = input.onblur = input.oninput = null;
  },
};
